import Card from "@Components/Decor/Card";
import Chip from "@Components/Decor/Chip";
import Tag from "@Components/Decor/Tag";
import Float from "@Components/Decor/Float";
import { CorrectIcon } from "@Icons/MainIcons";
import BoltIcon from "@Icons/MainIcons/BoltIcon";
import HeartIcon from "@Icons/MainIcons/HeartIcon";
import Star from "@Icons/MainIcons/StarIcon";
import IconHolder from "../../../../../../components/Decor/IconHolder";
import { useTranslation } from "react-i18next";

export default function LandingHeroDecor() {
  const { t } = useTranslation();

  return (
    <div className="pointer-events-none absolute inset-0" aria-hidden>
      <div className="absolute top-16 left-1/10 -rotate-3">
        <Float duration={5.5}>
          <Tag
            title={t("Landing.hero.earnedTitle")}
            subtitle={t("Landing.hero.earnedSubtitle")}
            icon={<Star className="bg-background-primary-lighter text-font-active h-full w-full rounded-full p-2.5" />}
          />
        </Float>
      </div>
      <div className="absolute top-68 left-1/14 rotate-6">
        <Float duration={6} delay={-2.5} distance={-10}>
          <Card
            title={t("Landing.hero.unlockedTitle")}
            subtitle={
              <div className="flex items-center gap-1">
                <CorrectIcon />
                {t("Landing.hero.unlockedSubtitle")}
              </div>
            }
          />
        </Float>
      </div>

      <div className="absolute top-20 right-1/10 rotate-3">
        <Float duration={5} delay={-3}>
          <Tag
            title={t("Landing.hero.fastTitle")}
            subtitle={t("Landing.hero.fastSubtitle")}
            icon={<BoltIcon className="bg-background-primary-lighter text-font-active h-full w-full rounded-full p-2" />}
          />
        </Float>
      </div>
      <div className="absolute top-52 right-1/20">
        <Float duration={3.5} delay={-0.6} distance={-6}>
          <IconHolder icon={<Star className="aspect-square w-8 p-2" />} />
        </Float>
      </div>
      <div className="absolute top-70 right-1/9 -rotate-3">
        <Float duration={4.5} delay={-1.8}>
          <Chip
            title={t("Landing.hero.treat")}
            icon={<HeartIcon className="h-3 w-3 text-white" />}
            className="bg-background-primary! text-white! outline-none!"
          />
        </Float>
      </div>
    </div>
  );
}
